module.exports = __webpack_public_path__ + "static/media/close_fullscreen.7a3c1b4b.svg";